/**
 * MODULE: _shared/frontend-shell/src/features/crm/components/shared/CrmAskAiIconButton.tsx
 * PURPOSE: Shared ⚡ Ask AI trigger for CRM drawers and headers
 * DEPENDENCIES: react, @heroicons/react/24/outline
 * PUBLIC_API: CrmAskAiIconButton, CrmAskAiIconButtonProps
 * SIDE_EFFECTS: click handler
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 45/200
 */

import { BoltIcon } from '@heroicons/react/24/outline';

export type CrmAskAiIconButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  /** e.g. opportunity-drawer-ask-ai */
  dataTestId: string;
};

export function CrmAskAiIconButton({ onClick, disabled, dataTestId }: CrmAskAiIconButtonProps) {
  return (
    <button
      type="button"
      data-testid={dataTestId}
      disabled={disabled}
      title="Ask AI"
      aria-label="Ask AI"
      onClick={onClick}
      className="inline-flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center gap-1.5 rounded-lg border border-amber-200 bg-amber-50 px-2 text-amber-900 transition-transform hover:bg-amber-100 focus-visible:outline focus-visible:ring-2 focus-visible:ring-primary-500 active:scale-95 disabled:cursor-not-allowed disabled:opacity-40 dark:border-amber-800/80 dark:bg-amber-950/40 dark:text-amber-100 dark:hover:bg-amber-900/50"
    >
      <BoltIcon className="h-5 w-5 shrink-0" aria-hidden />
      <span className="hidden text-xs font-semibold sm:inline">Ask AI</span>
    </button>
  );
}
